var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"personal-zdzk"},[_c('transition',{attrs:{"name":"fade-transform","mode":"out-in"}},[_c(_vm.componentName,{tag:"component",on:{"callback":_vm.callback}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }